<template>
  <div>
    <a-modal :visible="visible" title="新增文档" :width="1000" :maskClosable="false"
             okText="保存" cancelText="取消" :confirmLoading="loading" @ok="confirm" @cancel="handleCancel">
      <div ref="sheet" class="sheet">
        <div class="x-row r3">
          <div class="x-cell">
            <div class="x-label">寄件人、寄件时间 *</div>
            <div class="x-body"><span class="editable" contenteditable="true" aria-label="sender1"> </span></div>
          </div>
          <div class="x-cell">
            <div class="x-label">快递单号 *</div>
            <div class="x-body"><span class="editable" contenteditable="true" aria-label="express_no1"> </span></div>
          </div>
          <div class="x-cell">
            <div class="x-label">拍照（保存为 JPG）</div>
            <div class="x-body photo-cell">
              <img v-if="photo1" :src="photo1" class="photo-thumb" alt="photo1" />
              <a-button size="small" icon="camera" @click="openCamera('photo1')">{{ photo1 ? '重新拍照' : '拍照' }}</a-button>
              <a-button v-if="photo1" size="small" icon="delete" @click="photo1 = ''">清除</a-button>
            </div>
          </div>
        </div>

        <div class="x-row r1">
          <div class="x-cell">
            <div class="x-label">医院 *</div>
            <div class="x-body"><span class="editable" contenteditable="true" aria-label="hospital"> </span></div>
          </div>
        </div>

        <div class="x-row r2">
          <div class="x-cell">
            <div class="x-label">设备生产厂家 *</div>
            <div class="x-body"><span class="editable" contenteditable="true" aria-label="factory"> </span></div>
          </div>
          <div class="x-cell">
            <div class="x-label">型号名称 *</div>
            <div class="x-body"><span class="editable" contenteditable="true" aria-label="model"> </span></div>
          </div>
        </div>

        <div class="x-row r2">
          <div class="x-cell">
            <div class="x-label">机身号 *</div>
            <div class="x-body"><span class="editable" contenteditable="true" aria-label="body_no"> </span></div>
          </div>
          <div class="x-cell">
            <div class="x-label">维修编号</div>
            <div class="x-body"><span class="editable" contenteditable="true" aria-label="repair_no"> </span></div>
          </div>
        </div>

        <div class="x-row r1">
          <div class="x-cell">
            <div class="x-label">报修故障描述</div>
            <div class="x-body"><span class="editable area" contenteditable="true" aria-label="fault_desc"> </span></div>
          </div>
        </div>

        <div class="x-row r1">
          <div class="x-cell">
            <div class="x-label">上次维修时间及故障</div>
            <div class="x-body"><span class="editable area" contenteditable="true" aria-label="last_repair"> </span></div>
          </div>
        </div>

        <div class="x-row r3">
          <div class="x-cell">
            <div class="x-label">寄件人、寄件时间</div>
            <div class="x-body"><span class="editable" contenteditable="true" aria-label="sender2"> </span></div>
          </div>
          <div class="x-cell">
            <div class="x-label">快递单号</div>
            <div class="x-body"><span class="editable" contenteditable="true" aria-label="express_no2"> </span></div>
          </div>
          <div class="x-cell">
            <div class="x-label">拍照（保存为 JPG）</div>
            <div class="x-body photo-cell">
              <img v-if="photo2" :src="photo2" class="photo-thumb" alt="photo2" />
              <a-button size="small" icon="camera" @click="openCamera('photo2')">{{ photo2 ? '重新拍照' : '拍照' }}</a-button>
              <a-button v-if="photo2" size="small" icon="delete" @click="photo2 = ''">清除</a-button>
            </div>
          </div>
        </div>
      </div>
    </a-modal>

    <!-- 调用摄像头拍照 -->
    <a-modal v-model="cameraVisible" title="拍照" :width="560" :maskClosable="false" :footer="null" @cancel="stopCamera">
      <div style="text-align: center;">
        <video v-if="cameraVisible" ref="video" autoplay playsinline muted
               style="width: 100%; max-height: 380px; background: #000; border-radius: 4px;"
               @loadedmetadata="cameraReady = true"></video>
        <div v-if="!cameraReady" style="color: #999; padding: 24px 0;">正在打开摄像头，请允许摄像头权限…</div>
        <div style="margin-top: 12px;">
          <a-button type="primary" icon="camera" :disabled="!cameraReady" @click="capture">拍 照</a-button>
          <a-button style="margin-left: 12px;" @click="stopCamera">取 消</a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
// 必填校验规则：aria-label -> 显示名称
const REQUIRED = {
  sender1: '寄件人、寄件时间',
  express_no1: '快递单号',
  hospital: '医院',
  factory: '设备生产厂家',
  model: '型号名称',
  body_no: '机身号',
};
const EDITABLE_KEYS = ['sender1', 'express_no1', 'hospital', 'factory', 'model', 'body_no', 'repair_no', 'fault_desc', 'last_repair', 'sender2', 'express_no2'];

export default {
  name: 'RecordForm',
  props: ['visible', 'form'],
  model: { prop: 'visible', event: 'cancel' },
  data() {
    return {
      loading: false,
      cameraVisible: false,
      cameraReady: false,
      activePhoto: 'photo1',   // 当前拍照写入 photo1 还是 photo2
      photo1: '',              // JPG base64
      photo2: '',
      localStream: null,
    };
  },
  watch: {
    visible(val) {
      if (val) this.$nextTick(() => this.fillForm());
    },
    cameraVisible(val) {
      if (val) {
        this.cameraReady = false;
        this.$nextTick(() => {
          if (this.$refs.video) {
            this.startCamera();
          } else {
            this.$nextTick(() => this.startCamera());
          }
        });
      }
    },
  },
  beforeDestroy() {
    this.stopCamera();
  },
  methods: {
    fillForm() {
      const sheet = this.$refs.sheet;
      if (!sheet) return;
      sheet.querySelectorAll('.editable').forEach(el => {
        const key = el.getAttribute('aria-label');
        el.innerText = (this.form && this.form[key]) ? this.form[key] : '';
      });
      this.photo1 = (this.form && this.form.photo1) ? this.form.photo1 : '';
      this.photo2 = (this.form && this.form.photo2) ? this.form.photo2 : '';
    },
    readForm() {
      const data = {};
      this.$refs.sheet.querySelectorAll('.editable').forEach(el => {
        data[el.getAttribute('aria-label')] = el.innerText.trim();
      });
      data.photo1 = this.photo1;
      data.photo2 = this.photo2;
      return data;
    },
    confirm() {
      const data = this.readForm();
      // 必填校验：缺失则报错并聚焦第一个空单元格
      const missing = Object.keys(REQUIRED).filter(key => !data[key]);
      if (missing.length) {
        const names = missing.map(key => REQUIRED[key]);
        this.$message.error(`以下必填项不能为空：${names.join('、')}`);
        const first = this.$refs.sheet.querySelector(`.editable[aria-label="${missing[0]}"]`);
        if (first) first.focus();
        return;
      }
      this.$emit('save', data);
    },
    handleCancel() {
      this.stopCamera();
      this.$emit('cancel', false);
    },

    /* ---------- 摄像头拍照 ---------- */
    openCamera(slot) {
      this.activePhoto = slot;
      this.cameraVisible = true;
    },
    startCamera() {
      this.releaseStream();
      const video = this.$refs.video;
      if (!video) {
        this.$nextTick(() => this.startCamera());
        return;
      }
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        this.$message.error('当前浏览器不支持摄像头调用，请确保使用 HTTPS 协议访问');
        this.cameraVisible = false;
        return;
      }
      navigator.mediaDevices.getUserMedia({ video: { width: 1280, facingMode: 'environment' }, audio: false })
          .then(stream => {
            this.localStream = stream;
            if (this.$refs.video) {
              this.$refs.video.srcObject = stream;
            }
          })
          .catch(err => {
            this.$message.error(`无法访问摄像头：${err.message || '请检查权限及 HTTPS 配置'}`);
            this.cameraVisible = false;
          });
    },
    releaseStream() {
      if (this.localStream) {
        this.localStream.getTracks().forEach(track => track.stop());
        this.localStream = null;
      }
      if (this.$refs.video) {
        this.$refs.video.srcObject = null;
      }
      this.cameraReady = false;
    },
    stopCamera() {
      this.releaseStream();
      this.cameraVisible = false;
    },
    capture() {
      const video = this.$refs.video;
      if (!video || !video.videoWidth) {
        this.$message.warning('摄像头画面尚未就绪，请稍候');
        return;
      }
      // 画到 canvas 上，输出为 JPG
      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
      const jpg = canvas.toDataURL('image/jpeg', 0.85);
      this[this.activePhoto] = jpg;
      this.$message.success('已拍照并保存为 JPG');
      this.stopCamera();
    },
  },
}
</script>

<style scoped>
.sheet {
  border: 1px solid #c8d3e2;
  border-radius: 2px;
  overflow: hidden;
}
.x-row {
  display: grid;
  border-bottom: 1px solid #c8d3e2;
}
.x-row:last-child {
  border-bottom: none;
}
.r1 { grid-template-columns: 1fr; }
.r2 { grid-template-columns: 1fr 1fr; }
.r3 { grid-template-columns: 1fr 1fr 1fr; }
.x-cell {
  display: flex;
  flex-direction: column;
  min-height: 52px;
  border-right: 1px solid #c8d3e2;
}
.x-row > .x-cell:last-child {
  border-right: none;
}
.x-label {
  background: #eef2f7;
  border-bottom: 1px solid #d7e0ea;
  padding: 4px 10px;
  font-size: 13px;
  font-weight: 600;
  color: #1f3a5a;
  white-space: nowrap;
}
.x-body {
  flex: 1;
  display: flex;
  align-items: center;
  min-height: 28px;
}
.editable {
  flex: 1;
  display: inline-block;
  min-height: 26px;
  padding: 4px 10px;
  font-size: 14px;
  color: #0b1f33;
  outline: none;
  cursor: text;
  word-break: break-all;
}
.editable.area {
  min-height: 64px;
  align-items: flex-start;
}
.editable:hover {
  background: #f6f9ff;
}
.editable:focus {
  background: #fffbe6;
  box-shadow: inset 0 0 0 1px #f5c97b;
}
.editable:empty::before {
  content: attr(data-ph);
  color: #b7c3d1;
}
.photo-cell {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding: 6px 10px;
}
.photo-thumb {
  width: 64px;
  height: 44px;
  object-fit: cover;
  border: 1px solid #d7e0ea;
  border-radius: 2px;
}
@media (max-width: 700px) {
  .r2, .r3 { grid-template-columns: 1fr; }
}
</style>